import { Component, input } from '@angular/core';
import { BUTTON_TEXTS } from '../../../constants/buttons.constants';
import { RouterModule } from '@angular/router';
import {
  RdsCardModule,
  RdsIconsModule,
  RdsLinkModule,
} from '@rds/angular-components';
import { DynamicModule } from 'ng-dynamic-component';

@Component({
  selector: 'inexp-offering-vendor',
  imports: [
    RdsCardModule,
    RdsIconsModule,
    DynamicModule,
    RdsLinkModule,
    RouterModule,
  ],
  templateUrl: './offering-vendor.component.html',
  styleUrl: './offering-vendor.component.scss',
})
export class OfferingVendorComponent {
  _uid = input<string>();
  component = input<string>();
  section = input<any>();
  vendorName = input<string>();
  vendorSupport = input<string>();
  vendorUrl = input<string>();

  BUTTONS = BUTTON_TEXTS;
}
